import axios from 'axios'
import FileSaver from 'file-saver'
import qs from 'qs'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    audits: {
      tableData: [],
      totalAudits: 0
    },
    queryAudits: {
      page: 0,
      size: 20,
      sort: 'inputDateTime,DESC',
      dateTimeFrom: fn.initDateFrom(3),
      dateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersAudits: [],
    optionsFilterEmitter: [],
    optionsFilterReceiver: [],
    optionsFilterAuditDocumentType: [],
    optionsFilterAuditDocumentFormat: [],
    optionsFilterCommunication: [],
    optionsFilterModule: [],
    optionsFilterState: []
  }
  return session
}
function initLocal () {
  const local = {
    isShowEmisorAuditorias: true,
    isShowReceptorAuditorias: true,
    isShowFechaAuditorias: true,
    isShowNombreAuditorias: true,
    isShowNumDocumentoAuditorias: true,
    isShowTipoDocumentoAuditorias: true,
    isShowEstadoAuditorias: true,
    isShowServicioAuditorias: false,
    isShowComunicacionAuditorias: false,
    isShowModuleAuditorias: false,
    isShowLoteAuditorias: false,
    isShowProcessingTimeAuditorias: false    
  }
  return local
}
function setByUserLocalAudit () {
  const local = {
    optionsFilterAuditDocumentType: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.optionsFilterAuditDocumentType,
    optionsFilterAuditDocumentFormat: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.optionsFilterAuditDocumentFormat,
    optionsFilterCommunication: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.optionsFilterCommunication,
    optionsFilterModule: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.optionsFilterModule,
    optionsFilterState: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.optionsFilterState,
    isShowEmisorAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowEmisorAuditorias,
    isShowReceptorAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowReceptorAuditorias,
    isShowFechaAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowFechaAuditorias,
    isShowNombreAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowNombreAuditorias,
    isShowNumDocumentoAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowNumDocumentoAuditorias,
    isShowTipoDocumentoAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowTipoDocumentoAuditorias,
    isShowEstadoAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowEstadoAuditorias,
    isShowServicioAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowServicioAuditorias,
    isShowComunicacionAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowComunicacionAuditorias,
    isShowModuleAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowModuleAuditorias,
    isShowLoteAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowLoteAuditorias,
    isShowProcessingTimeAuditorias: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditorias.isShowProcessingTimeAuditorias
  }
  return local
}

const state = {
  userConfigLocalStorage: '',
  local: {
    optionsFilterAuditDocumentType: [],
    optionsFilterAuditDocumentFormat: [],
    optionsFilterCommunication: [],
    optionsFilterModule: [],
    optionsFilterState: [],
    isShowEmisorAuditorias: true,
    isShowReceptorAuditorias: true,
    isShowFechaAuditorias: true,
    isShowNombreAuditorias: true,
    isShowNumDocumentoAuditorias: true,
    isShowTipoDocumentoAuditorias: true,
    isShowEstadoAuditorias: true,
    isShowServicioAuditorias: false,
    isShowComunicacionAuditorias: false,
    isShowModuleAuditorias: false,
    isShowLoteAuditorias: false,
    isShowProcessingTimeAuditorias: false

  },
  session: initSession()
}
const getters = {
  audits: state => {
    return state.session.audits
  },
  queryAudits: state => {
    return state.session.queryAudits
  },
  listSelectedFiltersAudits: state => {
    return state.session.listSelectedFiltersAudits
  },
  optionsFilterEmitter: state => {
    return state.session.optionsFilterEmitter
  },
  optionsFilterReceiver: state => {
    return state.session.optionsFilterReceiver
  },
  optionsFilterAuditDocumentType: state => {
    return state.session.optionsFilterAuditDocumentType
  },
  optionsFilterAuditDocumentFormat: state => {
    return state.session.optionsFilterAuditDocumentFormat
  },
  optionsFilterState: state => {
    return state.session.optionsFilterState
  },
  optionsFilterCommunication: state => {
    return state.session.optionsFilterCommunication
  },
  optionsFilterModule: state => {
    return state.session.optionsFilterModule
  },
  isShowEmisorAuditorias: state => {
    return state.local.isShowEmisorAuditorias
  },
  isShowReceptorAuditorias: state => {
    return state.local.isShowReceptorAuditorias
  },
  isShowFechaAuditorias: state => {
    return state.local.isShowFechaAuditorias
  },
  isShowNombreAuditorias: state => {
    return state.local.isShowNombreAuditorias
  },
  isShowNumDocumentoAuditorias: state => {
    return state.local.isShowNumDocumentoAuditorias
  },
  isShowTipoDocumentoAuditorias: state => {
    return state.local.isShowTipoDocumentoAuditorias
  },
  isShowEstadoAuditorias: state => {
    return state.local.isShowEstadoAuditorias
  },
  isShowServicioAuditorias: state => {
    return state.local.isShowServicioAuditorias
  },
  isShowComunicacionAuditorias: state => {
    return state.local.isShowComunicacionAuditorias
  },
  isShowModuleAuditorias: state => {
    return state.local.isShowModuleAuditorias
  },
  isShowLoteAuditorias: state => {
    return state.local.isShowLoteAuditorias
  },
  isShowProcessingTimeAuditorias: state => {
    return state.local.isShowProcessingTimeAuditorias
  },
}

const actions = {

  // Crear key Usuario
  setUserNameAudit ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalAudit()
    }
  },

  isNewVersionAuditoriasLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.borradores)
  },
  /**
     * Servicio para traer las Auditorias.
     * Se utiliza también para ordenar la tabla, la paginación,
     * el tamaño de la tabla y los filtros.
     */
  async getAudits ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/auditdocument',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      commit('AUDITS_STATE', {
        tableData: response.data.content,
        totalAudits: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para Descargar Todas las Auditorias a CSV
     */
  async handleDownloadAllCsvAudits ({
    commit, rootState
  }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/auditdocument/csv',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params,
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'all-css-audits.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },
  /**
     * Servicio para descarga múltiple de Auditorias Peticion-Respues y Original o integrado
     */
  async handleDownloadMultiAudits ({
    commit, rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/auditdocument/downloadMultiple',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          auditoryIds: params.auditoryIds,
          pathType: params.pathType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'audits.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
     * Servicio para llenar Select Filtro tipo de
     * Documento.
     */
  async getOptionsFilterAuditDocumentType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterAuditDocumentType = response.data
      commit('OPTIONS_FILTER_AUDIT_DOCUMENT_TYPE_STATE', optionsFilterAuditDocumentType)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterAuditDocumentType
    } catch (error) {
      console.log('ERROR getOptionsFilterAuditDocumentType --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para llenar Select Filtro formato de
     * Documento.
     */
  async getOptionsFilterAuditDocumentFormat ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype/format',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterAuditDocumentFormat = response.data
      commit('OPTIONS_FILTER_AUDIT_DOCUMENT_FORMAT_STATE', optionsFilterAuditDocumentFormat)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterAuditDocumentFormat
    } catch (error) {
      console.log('ERROR getOptionsFilterAuditDocumentFormat --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para llenar Select Filtro Estados Auditorías
     */
  async getOptionsFilterStateAudits ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/auditstatus'
      })

      const optionsFilterState = response.data
      commit('OPTIONS_FILTER_STATE_AUDITS_STATE', optionsFilterState)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterState
    } catch (error) {
      console.log('ERROR getOptionsFilterStateAudits --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Protocolos
     * Comunicación Auditorías
     */
  async getOptionsFilterCommunication ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/communicationprotocol'
      })

      const optionsFilterCommunication = response.data
      commit('OPTIONS_FILTER_COMMUNICATION_AUDITS_STATE', optionsFilterCommunication)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterCommunication
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Modulo
     * Auditorías
     */
  async getOptionsFilterModule ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/auditdocumentmodule',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterModule = response.data
      commit('OPTIONS_FILTER_MODULE_AUDITS_STATE', optionsFilterModule)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterModule
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getAuditDocumentById ({
    commit, rootState
  }, idAuditDocument) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/auditdocument/' + idAuditDocument,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para traer Todos los eventos de la Auditoria
     */
  async getAuditsEvents ({
    commit, rootState
  }, idAudit) {
    try {
      const response = await axios({
        method: 'GET',
        url: `/auditdocument/${idAudit}/event`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getAuditsEvents --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para Descargar Fichero Original de Auditoria
     */
  async handleDownloadOriginalAudit ({
    commit, rootState
  }, idAudit) {
    try {
      const response = await axios({
        method: 'GET',
        url: `/auditdocument/${idAudit}/download`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          idAudit: idAudit
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'all-.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR handleDownloadOriginalAudit --- ', error)
      throw error.response
    }
  },
  /**
     * Servicio para Descargar Petición de Entrada de Auditoria
     */
  async handleDownloadEntryRequestAudit ({
    commit, rootState
  }, idAudit) {
    try {
      const response = await axios({
        method: 'GET',
        url: `/auditdocument/${idAudit}/downloadRequestResponse`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          pathType: 'REQUEST'
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'all-.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR handleEntryRequestAudit --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para Descargar Petición de Salida de Auditoria
     */
  async handleDownloadExitRequestAudit ({
    commit, rootState
  }, idAuditory) {
    try {
      const response = await axios({
        method: 'GET',
        url: `/auditdocument/${idAuditory}/downloadRequestResponse`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,        
        params: {
          pathType: 'RESPONSE',
          idAudit: idAuditory
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'all-.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR handleExitRequestAudit --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para Descargar Fichero de Entrada
     */
  async handleDownloadInAudit ({
    commit, rootState
  }, idAudit) {
    try {
      const response = await axios({
        method: 'GET',
        url: `/auditdocument/${idAudit}/downloadIn`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'all-.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR handleDownloadInAudit --- ', error)
      throw error.response
    }
  },
  auditsState: ({
    commit
  }, payload) => {
    commit('AUDITS_STATE', payload)
  },
  queryAuditsState: ({
    commit
  }, payload) => {
    commit('QUERY_AUDITS_STATE', payload)
  },
  listSelectedFiltersAuditsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_AUDITS_STATE', payload)
  },
  optionsFilterAuditDocumentType: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_AUDIT_DOCUMENT_TYPE_STATE', payload)
  },
  optionsFilterAuditDocumentFormat: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_AUDIT_DOCUMENT_FORMAT_STATE', payload)
  },
  optionsFilterStateState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_STATE_AUDITS_STATE', payload)
  },
  optionsFilterCommunicationState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_COMMUNICATION_AUDITS_STATE', payload)
  },
  optionsFilterModuleState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_MODULE_AUDITS_STATE', payload)
  },
  optionsFilterReceiverState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_RECEIVER_AUDITS_STATE', payload)
  },
  optionsFilterEmitterState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_EMITTER_AUDITS_STATE', payload)
  },
  isShowEmisorAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_EMISOR_AUDITORIAS', payload)
  },
  isShowReceptorAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_RECEPTOR_AUDITORIAS', payload)
  },
  isShowFechaAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_AUDITORIAS', payload)
  },
  isShowNombreAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NOMBRE_AUDITORIAS', payload)
  },
  isShowNumDocumentoAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_DOCUMENTO_AUDITORIAS', payload)
  },
  isShowTipoDocumentoAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_TIPO_DOCUMENTO_AUDITORIAS', payload)
  },
  isShowEstadoAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ESTADO_AUDITORIAS', payload)
  },
  isShowServicioAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_AUDITORIAS', payload)
  },
  isShowComunicacionAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COMUNICACION_AUDITORIAS', payload)
  },
  isShowModuleAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MODULE_AUDITORIAS', payload)
  },
  isShowLoteAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_LOTE_AUDITORIAS', payload)
  },
  isShowProcessingTimeAuditoriasAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PROCESSINGTIME_AUDITORIAS', payload)
  }  
}

const mutations = {
  resetSessionAuditorias (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  auditsDatesSUperAdmin (state) {
    state.session.queryAudits.dateTimeFrom = fn.initDateFromAudit(0)
  },
  'AUDITS_STATE' (state, payload) {
    state.session.audits = payload
  },
  'QUERY_AUDITS_STATE' (state, payload) {
    state.session.queryAudits = payload
  },
  'LIST_SELECTED_FILTERS_AUDITS_STATE' (state, payload) {
    state.session.listSelectedFiltersAudits = payload
  },
  'OPTIONS_FILTER_EMITTER_AUDITS_STATE' (state, payload) {
    state.session.optionsFilterEmitter = payload
  },
  'OPTIONS_FILTER_RECEIVER_AUDITS_STATE' (state, payload) {
    state.session.optionsFilterReceiver = payload
  },
  'OPTIONS_FILTER_AUDIT_DOCUMENT_TYPE_STATE' (state, payload) {
    state.session.optionsFilterAuditDocumentType = payload
  },
  'OPTIONS_FILTER_AUDIT_DOCUMENT_FORMAT_STATE' (state, payload) {
    state.session.optionsFilterAuditDocumentFormat = payload
  },
  'OPTIONS_FILTER_STATE_AUDITS_STATE' (state, payload) {
    state.session.optionsFilterState = payload
  },
  'OPTIONS_FILTER_COMMUNICATION_AUDITS_STATE' (state, payload) {
    state.session.optionsFilterCommunication = payload
  },
  'OPTIONS_FILTER_MODULE_AUDITS_STATE' (state, payload) {
    state.session.optionsFilterModule = payload
  },
  'IS_SHOW_EMISOR_AUDITORIAS' (state, payload) {
    state.local.isShowEmisorAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowEmisorAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEPTOR_AUDITORIAS' (state, payload) {
    state.local.isShowReceptorAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowReceptorAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_AUDITORIAS' (state, payload) {
    state.local.isShowFechaAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowFechaAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NOMBRE_AUDITORIAS' (state, payload) {
    state.local.isShowNombreAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowNombreAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_DOCUMENTO_AUDITORIAS' (state, payload) {
    state.local.isShowNumDocumentoAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowNumDocumentoAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TIPO_DOCUMENTO_AUDITORIAS' (state, payload) {
    state.local.isShowTipoDocumentoAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowTipoDocumentoAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ESTADO_AUDITORIAS' (state, payload) {
    state.local.isShowEstadoAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowEstadoAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICIO_AUDITORIAS' (state, payload) {
    state.local.isShowServicioAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowServicioAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COMUNICACION_AUDITORIAS' (state, payload) {
    state.local.isShowComunicacionAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowComunicacionAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MODULE_AUDITORIAS' (state, payload) {
    state.local.isShowModuleAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowModuleAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_LOTE_AUDITORIAS' (state, payload) {
    state.local.isShowLoteAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowLoteAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PROCESSINGTIME_AUDITORIAS' (state, payload) {
    state.local.isShowProcessingTimeAuditorias = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditorias.isShowProcessingTimeAuditorias = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }  
}

export default {
  state,
  getters,
  actions,
  mutations
}
